import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { DiagnoseTemplateBusinessService } from '../../business-services/diagnose-template.service';


@Injectable({ providedIn: 'root' })
export class EditDiagnoseTemplateGuard  {

  constructor(
    private diagnoseTemplateService: DiagnoseTemplateBusinessService,
    private router: Router
  ) { }

  canActivate(): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
    if (this.diagnoseTemplateService.diagnoseTemplateId) {
      return true;
    }
    return this.router.createUrlTree(['/diagnoseTemplate']);
  }
}